export default __webpack_public_path__ + "locales/el-GR/ChangeUserTypeDialog.json?hash=ab190d53747963eeab0b4f1ef334d361";